import { types } from 'mobx-state-tree'

export const AdminAthleteModel = types
  .model('AdminAthletesModel', {
    id: types.maybeNull(types.number),
    dateOfBirth: types.maybeNull(types.string),
    logo: types.maybeNull(types.string),
    sport: types.maybeNull(types.string),
    name: types.maybeNull(types.string),
    surname: types.maybeNull(types.string),
    nationality: types.maybeNull(types.string),
  })
  .preProcessSnapshot((snapshot) => ({
    ...snapshot,
  }))
